/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * RapidWorks REST API
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CertificateRequirementForEquipmentDto,
  CertificateRequirementForRolesDto,
  CreateCertificateRequirementForEquipmentInput,
  CreateCertificateRequirementForRolesInput,
  CreatePermitRequirementInput,
  GetApiV3PermitsCertificatesRequirementsParams,
  GetApiV3PermitsCertificatesRequirementsRequiredParams,
  PagedResultOfPermitCertificateRequirementListDto,
  PermitCertificateRequirementDetailDto,
  PermitRequirementDto,
  ProblemDetails,
  RequiredItemsResponseDto,
  UpdateCertificateRequirementForEquipmentInput,
  UpdateCertificateRequirementForRolesInput,
  UpdatePermitRequirementInput
} from '.././model';

import { axiosInstance } from '../../axios-instance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Creates a new permit requirement.
Input: PermitID, TargetType (1=Customer, 2=JobSite, 3=Job), and the corresponding target ID (CustomerID, JobSiteID, or PourId).
 */
export const postApiV3PermitsCertificatesRequirementsPermits = (
  createPermitRequirementInput: CreatePermitRequirementInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<PermitRequirementDto>(
    {
      url: `/api/v3/permits-certificates-requirements/permits`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createPermitRequirementInput,
      signal
    },
    options
  );
};

export const getPostApiV3PermitsCertificatesRequirementsPermitsMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsPermits>>,
    TError,
    { data: CreatePermitRequirementInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsPermits>>,
  TError,
  { data: CreatePermitRequirementInput },
  TContext
> => {
  const mutationKey = ['postApiV3PermitsCertificatesRequirementsPermits'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsPermits>>,
    { data: CreatePermitRequirementInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV3PermitsCertificatesRequirementsPermits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3PermitsCertificatesRequirementsPermitsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsPermits>>
>;
export type PostApiV3PermitsCertificatesRequirementsPermitsMutationBody = CreatePermitRequirementInput;
export type PostApiV3PermitsCertificatesRequirementsPermitsMutationError = ProblemDetails | void;

/**
 * @summary Creates a new permit requirement.
Input: PermitID, TargetType (1=Customer, 2=JobSite, 3=Job), and the corresponding target ID (CustomerID, JobSiteID, or PourId).
 */
export const usePostApiV3PermitsCertificatesRequirementsPermits = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsPermits>>,
      TError,
      { data: CreatePermitRequirementInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsPermits>>,
  TError,
  { data: CreatePermitRequirementInput },
  TContext
> => {
  const mutationOptions = getPostApiV3PermitsCertificatesRequirementsPermitsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Creates a new certificate requirement associated with one or more roles.
Creates the base requirement (PermitCertificateRequirement) and role associations (RaptorPermitCertificateRequirementRole).
 */
export const postApiV3PermitsCertificatesRequirementsCertificatesRoles = (
  createCertificateRequirementForRolesInput: CreateCertificateRequirementForRolesInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CertificateRequirementForRolesDto>(
    {
      url: `/api/v3/permits-certificates-requirements/certificates/roles`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCertificateRequirementForRolesInput,
      signal
    },
    options
  );
};

export const getPostApiV3PermitsCertificatesRequirementsCertificatesRolesMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesRoles>>,
    TError,
    { data: CreateCertificateRequirementForRolesInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesRoles>>,
  TError,
  { data: CreateCertificateRequirementForRolesInput },
  TContext
> => {
  const mutationKey = ['postApiV3PermitsCertificatesRequirementsCertificatesRoles'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesRoles>>,
    { data: CreateCertificateRequirementForRolesInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV3PermitsCertificatesRequirementsCertificatesRoles(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3PermitsCertificatesRequirementsCertificatesRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesRoles>>
>;
export type PostApiV3PermitsCertificatesRequirementsCertificatesRolesMutationBody = CreateCertificateRequirementForRolesInput;
export type PostApiV3PermitsCertificatesRequirementsCertificatesRolesMutationError = ProblemDetails | void;

/**
 * @summary Creates a new certificate requirement associated with one or more roles.
Creates the base requirement (PermitCertificateRequirement) and role associations (RaptorPermitCertificateRequirementRole).
 */
export const usePostApiV3PermitsCertificatesRequirementsCertificatesRoles = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesRoles>>,
      TError,
      { data: CreateCertificateRequirementForRolesInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesRoles>>,
  TError,
  { data: CreateCertificateRequirementForRolesInput },
  TContext
> => {
  const mutationOptions = getPostApiV3PermitsCertificatesRequirementsCertificatesRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Creates a new certificate requirement associated with one or more equipment types.
Creates the base requirement (PermitCertificateRequirement) and equipment associations (RaptorPermitCertificateRequirementEquipment).
 */
export const postApiV3PermitsCertificatesRequirementsCertificatesEquipment = (
  createCertificateRequirementForEquipmentInput: CreateCertificateRequirementForEquipmentInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<CertificateRequirementForEquipmentDto>(
    {
      url: `/api/v3/permits-certificates-requirements/certificates/equipment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCertificateRequirementForEquipmentInput,
      signal
    },
    options
  );
};

export const getPostApiV3PermitsCertificatesRequirementsCertificatesEquipmentMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesEquipment>>,
    TError,
    { data: CreateCertificateRequirementForEquipmentInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesEquipment>>,
  TError,
  { data: CreateCertificateRequirementForEquipmentInput },
  TContext
> => {
  const mutationKey = ['postApiV3PermitsCertificatesRequirementsCertificatesEquipment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesEquipment>>,
    { data: CreateCertificateRequirementForEquipmentInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiV3PermitsCertificatesRequirementsCertificatesEquipment(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiV3PermitsCertificatesRequirementsCertificatesEquipmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesEquipment>>
>;
export type PostApiV3PermitsCertificatesRequirementsCertificatesEquipmentMutationBody = CreateCertificateRequirementForEquipmentInput;
export type PostApiV3PermitsCertificatesRequirementsCertificatesEquipmentMutationError = ProblemDetails | void;

/**
 * @summary Creates a new certificate requirement associated with one or more equipment types.
Creates the base requirement (PermitCertificateRequirement) and equipment associations (RaptorPermitCertificateRequirementEquipment).
 */
export const usePostApiV3PermitsCertificatesRequirementsCertificatesEquipment = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesEquipment>>,
      TError,
      { data: CreateCertificateRequirementForEquipmentInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiV3PermitsCertificatesRequirementsCertificatesEquipment>>,
  TError,
  { data: CreateCertificateRequirementForEquipmentInput },
  TContext
> => {
  const mutationOptions = getPostApiV3PermitsCertificatesRequirementsCertificatesEquipmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Gets a single permit/certificate requirement by ID.
For certificate requirements, the response includes role type IDs and equipment associations.
 */
export const getApiV3PermitsCertificatesRequirementsId = (
  id: number,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<PermitCertificateRequirementDetailDto>(
    { url: `/api/v3/permits-certificates-requirements/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiV3PermitsCertificatesRequirementsIdQueryKey = (id?: number) => {
  return [`/api/v3/permits-certificates-requirements/${id}`] as const;
};

export const getGetApiV3PermitsCertificatesRequirementsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
  TError = ProblemDetails | void
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3PermitsCertificatesRequirementsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>> = ({ signal }) =>
    getApiV3PermitsCertificatesRequirementsId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3PermitsCertificatesRequirementsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>
>;
export type GetApiV3PermitsCertificatesRequirementsIdQueryError = ProblemDetails | void;

export function useGetApiV3PermitsCertificatesRequirementsId<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
  TError = ProblemDetails | void
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PermitsCertificatesRequirementsId<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
  TError = ProblemDetails | void
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PermitsCertificatesRequirementsId<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
  TError = ProblemDetails | void
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets a single permit/certificate requirement by ID.
For certificate requirements, the response includes role type IDs and equipment associations.
 */

export function useGetApiV3PermitsCertificatesRequirementsId<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>,
  TError = ProblemDetails | void
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3PermitsCertificatesRequirementsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deletes a permit/certificate requirement by ID.
 */
export const deleteApiV3PermitsCertificatesRequirementsId = (id: number, options?: SecondParameter<typeof axiosInstance>) => {
  return axiosInstance<void>({ url: `/api/v3/permits-certificates-requirements/${id}`, method: 'DELETE' }, options);
};

export const getDeleteApiV3PermitsCertificatesRequirementsIdMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof deleteApiV3PermitsCertificatesRequirementsId>>, TError, { id: number }, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<Awaited<ReturnType<typeof deleteApiV3PermitsCertificatesRequirementsId>>, TError, { id: number }, TContext> => {
  const mutationKey = ['deleteApiV3PermitsCertificatesRequirementsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiV3PermitsCertificatesRequirementsId>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteApiV3PermitsCertificatesRequirementsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiV3PermitsCertificatesRequirementsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiV3PermitsCertificatesRequirementsId>>
>;

export type DeleteApiV3PermitsCertificatesRequirementsIdMutationError = ProblemDetails | void;

/**
 * @summary Deletes a permit/certificate requirement by ID.
 */
export const useDeleteApiV3PermitsCertificatesRequirementsId = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiV3PermitsCertificatesRequirementsId>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteApiV3PermitsCertificatesRequirementsId>>, TError, { id: number }, TContext> => {
  const mutationOptions = getDeleteApiV3PermitsCertificatesRequirementsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Gets all permit/certificate requirements with filtering, sorting, and pagination.
Use `search` for global search across AssignedTo, Id, Level, PermitCertificateName, and Requirement.
 */
export const getApiV3PermitsCertificatesRequirements = (
  params?: GetApiV3PermitsCertificatesRequirementsParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<PagedResultOfPermitCertificateRequirementListDto>(
    { url: `/api/v3/permits-certificates-requirements`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiV3PermitsCertificatesRequirementsQueryKey = (params?: GetApiV3PermitsCertificatesRequirementsParams) => {
  return [`/api/v3/permits-certificates-requirements`, ...(params ? [params] : [])] as const;
};

export const getGetApiV3PermitsCertificatesRequirementsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3PermitsCertificatesRequirementsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>> = ({ signal }) =>
    getApiV3PermitsCertificatesRequirements(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3PermitsCertificatesRequirementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>
>;
export type GetApiV3PermitsCertificatesRequirementsQueryError = ProblemDetails | void;

export function useGetApiV3PermitsCertificatesRequirements<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
  TError = ProblemDetails | void
>(
  params: undefined | GetApiV3PermitsCertificatesRequirementsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PermitsCertificatesRequirements<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PermitsCertificatesRequirements<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets all permit/certificate requirements with filtering, sorting, and pagination.
Use `search` for global search across AssignedTo, Id, Level, PermitCertificateName, and Requirement.
 */

export function useGetApiV3PermitsCertificatesRequirements<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirements>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3PermitsCertificatesRequirementsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Gets required permit/certificate items filtered by one or more target IDs
(CustomerId, JobId, JobSiteId).
Returns a paged list of required items and summary counts (PermitsAssigned, PermitsUnassigned,
CertificatesAssigned, CertificatesUnassigned) for each requested target.
 */
export const getApiV3PermitsCertificatesRequirementsRequired = (
  params?: GetApiV3PermitsCertificatesRequirementsRequiredParams,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<RequiredItemsResponseDto>(
    { url: `/api/v3/permits-certificates-requirements/required`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiV3PermitsCertificatesRequirementsRequiredQueryKey = (
  params?: GetApiV3PermitsCertificatesRequirementsRequiredParams
) => {
  return [`/api/v3/permits-certificates-requirements/required`, ...(params ? [params] : [])] as const;
};

export const getGetApiV3PermitsCertificatesRequirementsRequiredQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsRequiredParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiV3PermitsCertificatesRequirementsRequiredQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>> = ({ signal }) =>
    getApiV3PermitsCertificatesRequirementsRequired(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiV3PermitsCertificatesRequirementsRequiredQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>
>;
export type GetApiV3PermitsCertificatesRequirementsRequiredQueryError = ProblemDetails | void;

export function useGetApiV3PermitsCertificatesRequirementsRequired<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
  TError = ProblemDetails | void
>(
  params: undefined | GetApiV3PermitsCertificatesRequirementsRequiredParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PermitsCertificatesRequirementsRequired<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsRequiredParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
          TError,
          Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiV3PermitsCertificatesRequirementsRequired<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsRequiredParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Gets required permit/certificate items filtered by one or more target IDs
(CustomerId, JobId, JobSiteId).
Returns a paged list of required items and summary counts (PermitsAssigned, PermitsUnassigned,
CertificatesAssigned, CertificatesUnassigned) for each requested target.
 */

export function useGetApiV3PermitsCertificatesRequirementsRequired<
  TData = Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>,
  TError = ProblemDetails | void
>(
  params?: GetApiV3PermitsCertificatesRequirementsRequiredParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV3PermitsCertificatesRequirementsRequired>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiV3PermitsCertificatesRequirementsRequiredQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates an existing permit requirement.
RequirementType is immutable and cannot be changed.
 */
export const putApiV3PermitsCertificatesRequirementsPermitsRequirementId = (
  requirementId: number,
  updatePermitRequirementInput: UpdatePermitRequirementInput,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<PermitRequirementDto>(
    {
      url: `/api/v3/permits-certificates-requirements/permits/${requirementId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updatePermitRequirementInput
    },
    options
  );
};

export const getPutApiV3PermitsCertificatesRequirementsPermitsRequirementIdMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsPermitsRequirementId>>,
    TError,
    { requirementId: number; data: UpdatePermitRequirementInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsPermitsRequirementId>>,
  TError,
  { requirementId: number; data: UpdatePermitRequirementInput },
  TContext
> => {
  const mutationKey = ['putApiV3PermitsCertificatesRequirementsPermitsRequirementId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsPermitsRequirementId>>,
    { requirementId: number; data: UpdatePermitRequirementInput }
  > = (props) => {
    const { requirementId, data } = props ?? {};

    return putApiV3PermitsCertificatesRequirementsPermitsRequirementId(requirementId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiV3PermitsCertificatesRequirementsPermitsRequirementIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsPermitsRequirementId>>
>;
export type PutApiV3PermitsCertificatesRequirementsPermitsRequirementIdMutationBody = UpdatePermitRequirementInput;
export type PutApiV3PermitsCertificatesRequirementsPermitsRequirementIdMutationError = ProblemDetails | void;

/**
 * @summary Updates an existing permit requirement.
RequirementType is immutable and cannot be changed.
 */
export const usePutApiV3PermitsCertificatesRequirementsPermitsRequirementId = <TError = ProblemDetails | void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsPermitsRequirementId>>,
      TError,
      { requirementId: number; data: UpdatePermitRequirementInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsPermitsRequirementId>>,
  TError,
  { requirementId: number; data: UpdatePermitRequirementInput },
  TContext
> => {
  const mutationOptions = getPutApiV3PermitsCertificatesRequirementsPermitsRequirementIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Updates an existing certificate requirement associated with roles.
Deletes all existing role associations and replaces them with the provided role type IDs.
 */
export const putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles = (
  requirementId: number,
  updateCertificateRequirementForRolesInput: UpdateCertificateRequirementForRolesInput,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CertificateRequirementForRolesDto>(
    {
      url: `/api/v3/permits-certificates-requirements/certificates/${requirementId}/roles`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCertificateRequirementForRolesInput
    },
    options
  );
};

export const getPutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRolesMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles>>,
    TError,
    { requirementId: number; data: UpdateCertificateRequirementForRolesInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles>>,
  TError,
  { requirementId: number; data: UpdateCertificateRequirementForRolesInput },
  TContext
> => {
  const mutationKey = ['putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles>>,
    { requirementId: number; data: UpdateCertificateRequirementForRolesInput }
  > = (props) => {
    const { requirementId, data } = props ?? {};

    return putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles(requirementId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRolesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles>>
>;
export type PutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRolesMutationBody = UpdateCertificateRequirementForRolesInput;
export type PutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRolesMutationError = ProblemDetails | void;

/**
 * @summary Updates an existing certificate requirement associated with roles.
Deletes all existing role associations and replaces them with the provided role type IDs.
 */
export const usePutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles = <
  TError = ProblemDetails | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles>>,
      TError,
      { requirementId: number; data: UpdateCertificateRequirementForRolesInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRoles>>,
  TError,
  { requirementId: number; data: UpdateCertificateRequirementForRolesInput },
  TContext
> => {
  const mutationOptions = getPutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdRolesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Updates an existing certificate requirement associated with equipment.
Deletes all existing equipment associations and replaces them with the provided equipment items.
 */
export const putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment = (
  requirementId: number,
  updateCertificateRequirementForEquipmentInput: UpdateCertificateRequirementForEquipmentInput,
  options?: SecondParameter<typeof axiosInstance>
) => {
  return axiosInstance<CertificateRequirementForEquipmentDto>(
    {
      url: `/api/v3/permits-certificates-requirements/certificates/${requirementId}/equipment`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateCertificateRequirementForEquipmentInput
    },
    options
  );
};

export const getPutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipmentMutationOptions = <
  TError = ProblemDetails | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment>>,
    TError,
    { requirementId: number; data: UpdateCertificateRequirementForEquipmentInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment>>,
  TError,
  { requirementId: number; data: UpdateCertificateRequirementForEquipmentInput },
  TContext
> => {
  const mutationKey = ['putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment>>,
    { requirementId: number; data: UpdateCertificateRequirementForEquipmentInput }
  > = (props) => {
    const { requirementId, data } = props ?? {};

    return putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment(requirementId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment>>
>;
export type PutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipmentMutationBody =
  UpdateCertificateRequirementForEquipmentInput;
export type PutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipmentMutationError = ProblemDetails | void;

/**
 * @summary Updates an existing certificate requirement associated with equipment.
Deletes all existing equipment associations and replaces them with the provided equipment items.
 */
export const usePutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment = <
  TError = ProblemDetails | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment>>,
      TError,
      { requirementId: number; data: UpdateCertificateRequirementForEquipmentInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipment>>,
  TError,
  { requirementId: number; data: UpdateCertificateRequirementForEquipmentInput },
  TContext
> => {
  const mutationOptions = getPutApiV3PermitsCertificatesRequirementsCertificatesRequirementIdEquipmentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
